import { JsonServiceClient } from "@servicestack/client"

export const DefaultClient = (baseUrl?: string, basePath?: string, theme?: string) => {
    const client = new JsonServiceClient(baseUrl)
        .apply(c => {
            c.basePath = basePath ?? null;
            c.headers = new Headers() //avoid pre-flight CORS requests
        });

    client.exceptionFilter = (res: Response, error: any) => {
        if (res.status === 401 || error.responseStatus.message === 'Unauthorized') {
            let pathName = location.pathname;
    
            if (pathName.startsWith('/,https://')) {
                let pathNameParts = pathName.split('/');
    
                if (pathNameParts.length > 4) {
                    pathName = '/' + pathNameParts.slice(4).join('/');
                }
                else {
                    pathName = '/';
                }
            }
    
            global.location.href = `/auth/openiddict?redirect=${encodeURIComponent(pathName + location.search)}&theme=${theme}`

        }
    };

    return client
}



export default DefaultClient;